import {
  GET_SUBCATEGORIES,
  GET_SUBCATEGORY,
  ERROR_SUBCATEGORY,
} from "../actions/types";

const inialState = {
  subCategories: [],
  subCategory: null,
  loading: true,
  error: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = inialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SUBCATEGORIES:
      return {
        ...state,
        subCategories: payload,
        loading: false,
      };
    case GET_SUBCATEGORY:
      return {
        ...state,
        subCategory: payload,
        loading: false,
      };
    case ERROR_SUBCATEGORY:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    default:
      return state;
  }
}
